import React, {useContext,useState, useEffect} from "react";
import AxiosRequest from "../helpers/AxiosRequest";
import {Redirect} from "react-router-dom";
import {SideContext} from "../contexts/SideContext";
import {CubeContext} from "../contexts/CubeContext";

const TokenAuth = (props) => {
    const [success, setSuccess] = useState(false);
    const {getSideKey} = useContext(SideContext);
    const {setCubeToken} = useContext(CubeContext);
    const [pathname, setPathname] = useState('');

    useEffect(() => {
        let token = props.match.params.token;
        let imba_id = props.match.params.imba_id;
        localStorage.setItem('comet-token', token)
        localStorage.setItem('token', token)
        AxiosRequest('auth_by_token', {
            imba_id
        }).then((response) => {
            if (response.error != 0){
                localStorage.setItem('user_id', response.user_id)
                localStorage.setItem('comet-user-id', response.user_id);
                localStorage.setItem('cube-token', response.cube_jwt);
                let key = getSideKey();
                switch (key) {
                    case 0:
                    case 1:
                        setPathname(`/${imba_id}`)
                        break;
                    case 2:
                        setPathname(`/${imba_id}/users`)
                        break;
                    case 3:
                        setPathname(`/${imba_id}/messages`)
                        break;
                    case 4:
                        setPathname(`/${imba_id}/rooms`)
                        break;
                }
                setCubeToken(response.cube_jwt)
                setSuccess(true)
                setTimeout(()=>window.location.href = `/#/${props.match.params.imba_id}/`,5000)
            } else {
                localStorage.clear('comet-user-id')
                localStorage.clear('comet-token')
                localStorage.clear('cube-token')
                window.location.href = `/#/${props.match.params.imba_id}/signIn`
            }
        })
    }, [])

    return (
        <h1>Wait for checking user</h1>
    )
}

export default TokenAuth;